<template>
  <div id="app-main-header">
    <!-- LOGO -->
    <img id="app-header-logo" alt="LOGO" src="../../assets/img/logo.png" v-on:click="$router.push('/')" height="50"
         width="150"/>
    <!-- 菜单 -->
    <div id="app-header-menu">
      <HeaderMenu></HeaderMenu>
    </div>
    <!-- 右边栏 -->
    <div id="app-header-right">
      <!-- 搜索 -->
      <HeaderSearch></HeaderSearch>
      <!-- 登录或用户 -->
      <HeaderUser></HeaderUser>
    </div>
  </div>
</template>

<script>
import HeaderMenu from "@/views/share/header/HeaderMenu";
import HeaderSearch from "@/views/share/header/HeaderSearch";
import HeaderUser from "@/views/share/header/HeaderUser";

export default {
  name: "HeaderMain",
  components: {
    HeaderUser,
    HeaderSearch,
    HeaderMenu
  }
}
</script>

<style scoped>

#app-main-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.10);
  background: #FFFFFF;
  line-height: 60px;
  z-index: 1000;
}

#app-header-menu {
  position: absolute;
  top: 0;
  left: 160px;
  max-height: 60px;
  display: block;
}

#app-header-logo {
  position: absolute;
  left: 0;
  margin-top: 5px;
  margin-left: 10px;
  cursor: pointer;
}

#app-header-right {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 180px;
  font-size: 25px;
  line-height: 60px;
}

</style>